module.exports = __webpack_public_path__ + "static/img/landscape-3.5d70e44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landscapes/landscape-3.jpg
// module id = Iy32
// module chunks = 1